import { useSyncExternalStore } from 'react';
import { isSessionExpired, subscribeToSessionExpiry } from '@/lib/sessionExpiry';

/**
 * Whether the session has lapsed and the re-auth dialog should be showing.
 *
 * Backed by the module-level store in `lib/sessionExpiry` rather than a context,
 * because the axios interceptor that flips the flag is installed at module
 * scope — before any provider exists — so it has nowhere to dispatch into.
 */
export function useSessionExpired(): boolean {
  return useSyncExternalStore(subscribeToSessionExpiry, isSessionExpired, () => false);
}
